import { logger } from './logglyLogger';

const RESIZE_OBSERVER_NOISE =
  'ResizeObserver loop completed with undelivered notifications';

function isResizeObserverNoise(message?: string): boolean {
  return !!message && message.includes(RESIZE_OBSERVER_NOISE);
}

export function initBrowserLogging(): void {
  const originalError = console.error.bind(console);
  const originalWarn = console.warn.bind(console);

  console.error = (...args: unknown[]) => {
    originalError(...args);
    logger.logFromConsole('error', args);
  };

  console.warn = (...args: unknown[]) => {
    originalWarn(...args);
    logger.logFromConsole('warn', args);
  };

  window.addEventListener('error', (event) => {
    if (isResizeObserverNoise(event.message)) {
      event.stopImmediatePropagation();
      return;
    }

    logger.error(
      event.message || 'Unhandled window error',
      event.error,
      {
        sourceFile: 'window',
        sourceClass: 'Window',
        sourceLayer: 'Browser',
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
      }
    );
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const message =
      reason instanceof Error
        ? reason.message
        : typeof reason === 'string'
          ? reason
          : 'Unhandled promise rejection';

    if (isResizeObserverNoise(message)) {
      event.preventDefault();
      return;
    }

    logger.error(
      `Unhandled promise rejection: ${message}`,
      reason instanceof Error ? reason : undefined,
      {
        sourceFile: 'window',
        sourceClass: 'Promise',
        sourceLayer: 'Browser',
        reason: reason instanceof Error ? undefined : String(reason),
      }
    );
  });
}
